import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors, InputBase } from '@mui/material';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../components/ModalDialog/ModalDialog.js';
import { SetFormState, ToggleRemoveRepositoryFileDialog, RemoveRepositoryFile } from '../../actions/RepositoryExcelActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const RepositoryFileRemoveDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	// const roles = useSelector((state) => state.usersReducer.roles);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const tableId = useSelector((state) => state.repositoryExcelReducer.tableId);
	const filename = useSelector((state) => state.repositoryExcelReducer.filename);

	const _onConfirmClick = () => {
		dispatch(RemoveRepositoryFile(userId, tableId, filename));
		dispatch(ToggleRemoveRepositoryFileDialog(false));
		dispatch(enqueueSnackbar({ message: 'File removed', options: { variant: 'info' } }));
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Remove Excel file"
			confirmLabel="Ok"
			onConfirmClicked={_onConfirmClick}
		>
			<InputBase
				className={classes.margin}
				defaultValue={`Do you want to remove ${filename}?`}
				inputProps={{ 'aria-label': 'naked' }}
				fullWidth
			/>
		</ModalDialog>
	);
};

RepositoryFileRemoveDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default RepositoryFileRemoveDialog;
